import * as moment from "moment";
import { CommonConstants } from "../common.constant";
import { DateValidator } from "./date-validator";

export class Validator {

    constructor() { }

    errors = [];
    dateValidator = new DateValidator();
    dateDisplayFormat = "MM/DD/YYYY HH:mm";

    validate(model, parameters) {
        this.errors = [];
        parameters.forEach(parameter => {
            if (!model.hasOwnProperty(parameter) || (model[parameter] === null || model[parameter] === "" || model[parameter] === undefined)) {
                this.errors.push(parameter);
            }
        });
        return this.errors;
    }

    validateForEmpty(model, parameters) {
        this.errors = [];
        parameters.forEach(parameter => {
            if (!model.hasOwnProperty(parameter) || (model[parameter] == null || '' + model[parameter] + '' == '' || model[parameter] == undefined)) {
                this.errors.push(parameter);
            }
        });
        return this.errors;
    }

    validateDataTypeAndReturnNames(model, parameters) {
        this.errors = [];
        parameters.forEach(parameter => {
            if (!model.hasOwnProperty(parameter.name) || (model[parameter.name] == null || model[parameter.name] == "" || model[parameter.name] == undefined)) {
                // Do nothing
            } else if (this.canParse(model[parameter.name], parameter.type)) {
                this.errors.push(parameter.name);
            }
        });
        return this.errors;
    }

    validateDataType(model, parameters) {
        this.errors = [];
        parameters.forEach(parameter => {
            if (!model.hasOwnProperty(parameter.name) || (model[parameter.name] == null || model[parameter.name] == "" || model[parameter.name] == undefined)) {
                this.errors.push(parameter.name);
            } else if (this.canParse(model[parameter.name], parameter.type)) {
                this.errors.push(parameter.name + parameter.type);
            }
        });
        return this.errors;
    }

    validateDataTypeInList(models, parameters) {
        this.errors = [];

        models.forEach((model, index) => {
            parameters.forEach(parameter => {
                if (!model.hasOwnProperty(parameter.name) || (model[parameter.name] == null || model[parameter.name] == "" || model[parameter.name] == undefined)) {
                    this.errors.push(parameter.name + "_" + index);
                } else if (this.canParse(model[parameter.name], parameter.type)) {
                    this.errors.push(parameter.name + parameter.type + "_" + index);
                }
            });
        });
        return this.errors;
    }


    canParse(value, type) {
        var result = false;
        switch (type) {
            case 'Number':
                result = isNaN(value);
                break;
            case 'String':
                result = (typeof value == 'string');
                break;
            case 'Date':
                result = this.dateValidator.validate(value);
                break;
            case 'PositiveNumber':
                result = isNaN(value) || parseFloat(value) <= 0;
                break;
            case 'NonNegativeNumber':
                result = isNaN(value) || parseFloat(value) < 0;
                break;
            case 'PositiveWholeNumber':
                result = isNaN(value) || parseFloat(value) <= 0 || parseFloat(value) - parseInt(value) != 0;
                break;
            case 'NonNegativeWholeNumber':
                result = isNaN(value) || parseFloat(value) < 0 || parseFloat(value) - parseInt(value) != 0;
                break;
            // SB-4411
            case 'isNumber':
                result = isNaN(value)
                break;
            default:
                break;
        }
        return result;
    }

    validateRepeatPeriod(schedule) {
        var retVal = false;
        switch (schedule.repeatOption.description) {
            case CommonConstants.Daily:
                retVal = schedule.repeatPeriod ? true : false;
                break;
            case CommonConstants.Weekly:
                for (var i = 0; i < schedule.daysOfWeek.length; i++) {
                    if (schedule.daysOfWeek[i]) {
                        retVal = true;
                        break;
                    }
                }
                break;
            case CommonConstants.Monthly:
                retVal = schedule.repeatPeriod ? true : false;
                break;
            default:
                retVal = true;
        }
        return retVal;
    }

    validateStartDate(schedule, dateParam) {
        return schedule[dateParam] != null && schedule[dateParam] != "";
    }

    validateValidStartDate(schedule, dateParam) {
        var isOk = false;
        if (schedule[dateParam] != "") {
            if ((moment(schedule[dateParam], 'MM/DD/YYYY HH:mm', true).isValid()) ||
                (moment(schedule[dateParam], 'MM/DD/YYYY', true).isValid())) {
                isOk = false;
            } else {
                isOk = true;
            }
        }
        return isOk;
    }

    validateValidStartDateTime(schedule, dateParam) {
        var isOk = false;
        if (schedule[dateParam] != "") {
            if ((moment(schedule[dateParam], 'MM/DD/YYYY HH:mm', true).isValid())) {
                isOk = false;
            } else {
                isOk = true;
            }
        }
        return isOk;
    }

    validateEndDateTime(schedule, dateParam) {
        if (schedule.endingOption == 3) {
            return schedule[dateParam] != "null" && schedule[dateParam] != "";
        }
        return true;
    }

    validateDateInput(data, dateParam) {
        return !this.dateValidator.validate(data[dateParam]);
    }

    validateEndDate(schedule, dateParam) {
        var isOk = true;
        if (schedule.endingOption == 2 && (!schedule.numberOfOccurrences)) {
            isOk = false;
        }
        if (schedule.endingOption == 3 && (!schedule.endDateInput) && dateParam == "endDate") {
            isOk = false;
        }
        if (schedule.endingOption == 3 && schedule.endDateInput && dateParam == "endDateInput") {
            if (schedule[dateParam] != "") {
                if ((moment(schedule[dateParam], 'MM/DD/YYYY HH:mm', true).isValid())) {
                    isOk = true;
                } else {
                    isOk = false;
                }
            }
            else {
                isOk = true;
            }
        }
        return isOk;
    }

    validateUses(uses) {
        var status = false;
        for (var i = 0; i < uses.length; i++) {
            if (uses[i].selected && typeof uses[i].uom === "undefined") {
                status = true;
                break;
            }
        }
        return status;
    }

    checkDuplicateName(list, updatedObj) {
        updatedObj.invalidName = false;
        updatedObj.errorName = false;
        if (!updatedObj.name) {
            updatedObj.errorName = true;
        }
        list.forEach((obj) => {
            if ((obj.name != null && updatedObj.name != null) && updatedObj.name.toUpperCase() == obj.name.toUpperCase() && updatedObj.id != obj.id) {
                updatedObj.invalidName = true;
            }
        });
    }

    validateRange(value, min, max) {
        var error = null;
        if (value == null) {
            error = "Required";
        } else if (isNaN(value)) {
            error = "Invalid";
        } else if (min != null && max != null && (value < min || value > max)) {
            error = "OutOfRange";
        } else if (max != null && value > max) {
            error = "AboveThreshold";
        } else if (min != null && value < min) {
            error = "BelowThreshold";
        }
        return error;
    }

    validateDateRange(startDate, endDate, allowedRange) {
        var start = moment(startDate, this.dateDisplayFormat);
        var end = moment(endDate, this.dateDisplayFormat);
        var error = null;
        if (!start.isValid()) {
            error = "InvalidStartDate";
        } else if (!end.isValid()) {
            error = "InvalidEndDate";
        } else if (start.isAfter(end)) {
            error = "InvalidRange";
        } else if (Math.abs(start.diff(end, 'days')) > allowedRange) {
            error = "OutOfRange";
        }
        return error;
    }


}